import { FC, useRef, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Button } from '../Button'
import { validateEmail } from '../../featureSliced/shared/utils/validateEmail'
import { useTranslations } from '../../featureSliced/shared/hooks/useTranslations'
import { ReceiptModalContainer, ReceiptInput } from './styled'
import { errorHandler } from '../ErrorHandler'
import { GridDiv } from '../../featureSliced/shared/utils/gridDiv'
import { qrMenuPOST } from 'featureSliced/shared/api/qrMenu/POST'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { ToastsSlice } from 'featureSliced/shared/store/reducers/ToasterReducer'

type EmailPromptType = {
  onCloseModal: () => void
}

export const EmailPrompt: FC<EmailPromptType> = ({ onCloseModal }) => {
  const t = useTranslations()
  const inputRef = useRef<HTMLInputElement>(null)
  const [email, setEmail] = useState('')
  const [searchParams] = useSearchParams()
  const dispatch = useMyDispatch()
  const openToast = ToastsSlice.actions.openToast
  const datatransTrxId = searchParams.get('datatransTrxId')
  const saferPayOrderGuid = searchParams.get('orderGuid')

  useEffect(() => {
    setTimeout(() => {
      inputRef.current?.focus()
      inputRef.current?.select()
    }, 0)
  }, [inputRef])

  const handleSend = async () => {
    try {
      if ((datatransTrxId || saferPayOrderGuid) && validateEmail(email)) {
        const res = await qrMenuPOST.sendReseipt(
          email,
          datatransTrxId,
          saferPayOrderGuid
        )
        if (res.success && !!onCloseModal) {
          onCloseModal()
        }
      } else {
        dispatch(
          openToast({
            message: t('errors.invalidEmail'),
            type: 'error',
          })
        )
      }
    } catch (e) {
      dispatch(
        openToast({
          // TODO: translations
          message: t('errors.failedToSendReceipt'),
          type: 'error',
        })
      )
    }
  }

  return (
    <ReceiptModalContainer>
      <GridDiv gc="1 / -1">
        <ReceiptInput
          ref={inputRef}
          value={email}
          onChange={(e: any) => setEmail(e.currentTarget.value)}
        />
      </GridDiv>
      <GridDiv gc="1 / -1">
        <Button buttonType="common" width="100%" onClick={handleSend}>
          {t('buttons.send')}
        </Button>
      </GridDiv>
    </ReceiptModalContainer>
  )
}
